import qs from 'qs';
import { network } from 'services/network';

export const setSubProgramPreferenceToggleDate = ({ subProgramId, option }: OverdueAndUrgentDateThreshold) => {
    const querystring = qs.stringify({ subProgramId, option }, { addQueryPrefix: true, skipNulls: true });
    const url = `api/bo/setSubProgramPreferenceToggleDate${querystring}`;
    return network.post(url).then((response) => response.data);
};
